var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookmark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M7.99118 16.6215L1.49945 19.864C1.00921 20.1302 0.397683 19.9525 0.123484 19.4643C0.0434041 19.3108 0.00105752 19.1402 0 18.9668V11.7087C0 12.4283 0.405733 12.8725 1.47299 13.37L7.99118 16.6215Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.89526 0H11.0695C13.7773 0 15.9735 1.06605 16 3.79337V18.9668C15.9989 19.1374 15.9565 19.3051 15.8765 19.4554C15.7479 19.7007 15.5259 19.8827 15.2615 19.9598C14.997 20.0368 14.7128 20.0023 14.4741 19.8641L7.99118 16.6215L1.47299 13.3701C0.405733 12.8726 0 12.4284 0 11.7088V3.79337C0 1.06605 2.19625 0 4.89526 0ZM4.22492 7.62227H11.7486C12.1822 7.62227 12.5336 7.26828 12.5336 6.83162C12.5336 6.39495 12.1822 6.04096 11.7486 6.04096H4.22492C3.79137 6.04096 3.43991 6.39495 3.43991 6.83162C3.43991 7.26828 3.79137 7.62227 4.22492 7.62227Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.1b20d8372d88c8ba1fb25369fd621e56.svg";
export { ForwardRef as ReactComponent };